import { ValidatePaymentResponse } from '@features/payment'
import { podoFetcher } from '@server/infrastructure/external-apis/podo/client'

export interface PaymentExpectation {
  expectedSalePrice?: number
  expectedTotalLessonCount?: number
  expectedValidityMonths?: number
}

export const paymentEntityMutations = {
  validatePayment: ({
    subscribeId,
    productId,
    noticeVersionId,
    bearerToken,
    expectedSalePrice,
    expectedTotalLessonCount,
    expectedValidityMonths,
  }: RequestQueryOptions<
    { subscribeId?: string; productId?: string; noticeVersionId?: string } & PaymentExpectation
  >) => ({
    mutationKey: ['validatePayment', subscribeId, productId, noticeVersionId],
    mutationFn: async () => {
      const searchParams = new URLSearchParams()
      if (productId) {
        searchParams.set('productId', productId)
      }
      if (subscribeId) {
        searchParams.set('subscribeId', subscribeId)
      }
      if (noticeVersionId) {
        searchParams.set('noticeVersionId', noticeVersionId)
      }

      for (const [key, value] of Object.entries({
        expectedSalePrice,
        expectedTotalLessonCount,
        expectedValidityMonths,
      })) {
        if (value !== undefined) searchParams.set(key, String(value))
      }

      return await podoFetcher<ValidatePaymentResponse>({
        method: 'GET',
        url: `/api/v2/payment/purchases/validate?${searchParams.toString()}`,
        header: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
    },
  }),
}
